@use '@lib/assets/styles/main.scss' as *;

// NOTE: These toggle styles are reused by CheckBoxAsToggleCard component
// When modifying, ensure changes work for both components

.toggleRoot {
  display: block;
  border: 2px solid $gray700;
  background-color: $blue20;
  text-indent: -9999px;
  position: relative;
  transition: border .2s ease, background-color .2s ease;
  &.toggleRootLarge {
    width: 52px;
    height: 32px;
    border-radius: 100px;
    &:before {
      width: 16px;
      height: 16px;
      margin-left: -10px;
    }
  }
  &.toggleRootSmall {
    width: 26px;
    height: 18px;
    border-radius: 100px;
    &:before {
      width: 8px;
      height: 8px;
      margin-left: -4px;
    }
  }
  &:before {
    content: '';
    border-radius: 50%;
    background-color: $gray700;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: background-color 0.2s ease, margin-left 0.3s ease, width 0.15s 0.1s ease, height 0.15s 0.1s ease;
  }
  &.toggleRootChecked {
    background-color: $blue500;
    border-color: $blue500;
    &.toggleRootLarge {
      &:before {
        width: 24px;
        height: 24px;
        background-color: $gray0;
        margin-left: 10px;
      }
    }
    &.toggleRootSmall {
      &:before {
        width: 12px;
        height: 12px;
        background-color: $gray0;
        margin-left: 4px;
      }
    }
  }
  &.toggleRootDisabled {
    border: 2px solid $disable300;
    background-color: $disable100;
    &:before {
      background-color: $disable300;
    }
  }
}

.toggleLabelDisabled {
  color: $disable500;
}

.toggleWrap {
  display: block;
}

.toggleGrid {
  display: grid;
  grid-template-columns: min-content minmax(0, auto);
  align-items: center;
  &.toggleLarge {
    gap: 16px;
  }
  &.toggleSmall {
    gap: 8px;
  }
}

.toggleGridWithRightIcon {
  display: inline-grid;
  grid-template-columns: min-content minmax(0, auto) min-content;
  align-items: center;
  &.toggleLarge {
    gap: 16px;
  }
  &.toggleSmall {
    gap: 8px;
  }
}

.rightLabelIcon {
  & * {
    display: block;
  }
}

.input {
  display: none;
}
